import { render } from "./index.vue?vue&type=template&id=9b1b9ade"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9b1b9ade&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BaseUi/LoadingModalwithText/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b1b9ade"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b1b9ade', __exports__)) {
    api.reload('9b1b9ade', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=9b1b9ade", () => {
    api.rerender('9b1b9ade', render)
  })

}


export default __exports__